var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFrame(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.999 6.375H13.499C13.499 4.24725 11.4328 3.27675 9.74902 3.05325V1.5H8.24902V3.05325C6.56527 3.27675 4.49902 4.24725 4.49902 6.375C4.49902 8.4045 6.49852 9.45975 8.24902 9.6975V13.425C7.16302 13.2368 5.99902 12.657 5.99902 11.625H4.49902C4.49902 13.5668 6.31777 14.7143 8.24902 14.952V16.5H9.74902V14.9475C11.4328 14.724 13.499 13.7528 13.499 11.625C13.499 9.49725 11.4328 8.52675 9.74902 8.30325V4.575C10.7465 4.75425 11.999 5.28075 11.999 6.375ZM5.99902 6.375C5.99902 5.28075 7.25152 4.75425 8.24902 4.575V8.17425C7.22077 7.9845 5.99902 7.42275 5.99902 6.375ZM11.999 11.625C11.999 12.7193 10.7465 13.2458 9.74902 13.425V9.825C10.7465 10.0043 11.999 10.5308 11.999 11.625Z",
    fill: "#525866",
    stroke: "#525866",
    strokeWidth: 0.166667
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame);
export default __webpack_public_path__ + "static/media/Frame.4ae1392fb62de5b41b26acdda9cb90bd.svg";
export { ForwardRef as ReactComponent };